import {useQuery} from '@aboutyou/data-fetcher';
export interface ScayleConfig {
  currency: string;
  version: string;
  locale: string;

  dynamicFields?: {
    paymentOptions?: {
      zalandoConsent?: {
        conditions?: {
          enabled?: {
            paymentOptionKey?: string[];
          };
        };
      };
    };
  };
}

export const useScayleConfig = () => {
  const query = useQuery<ScayleConfig | null>('scayleConfig', () => {
    return new Promise<ScayleConfig | null>(resolve => {
      const checkScayleConfig = () => {
        if (window.scayle?.config) {
          resolve(window.scayle.config);
        } else {
          setTimeout(checkScayleConfig, 30);
        }
      };
      checkScayleConfig();
    });
  });

  return query;
};
